import { ConversationService } from "@forwardflow/services/ConversationService"

const mapCallOutcome = (endedReason: string): { itemType: string; itemActionStatus: string } => {
  const endOfCallReason = endedReason.trim();
  switch (endOfCallReason) {
    case 'customer-ended-call':
      return {
        itemType: 'call',
        itemActionStatus: 'ended'
      }

    case 'customer-did-not-answer':
      return {
        itemType: 'call',
        itemActionStatus: 'missed'
      }

    case 'voicemail':
      return {
        itemType: 'voicemail',
        itemActionStatus: 'voicemail_sent'
      }

    default:
      return {
        itemType: 'call',
        itemActionStatus: 'ended'
      }
  }
}

export const mapCallReportToTimelineItem = async (
  endOfCallReport: any,
): Promise<any> => {
  const { itemType, itemActionStatus } = mapCallOutcome(endOfCallReport.endedReason || '');
  
  const isMissedCall = itemActionStatus === 'missed';
  const isVoicemail = itemType === 'voicemail';
  
  const callSummary = endOfCallReport.analysis?.summary;
  const duration = endOfCallReport.durationSeconds || 0;
  const callId = endOfCallReport.call?.callSid || endOfCallReport.call?.id;
  const isIncoming = endOfCallReport.isIncomingCall || false;
  const recordId = Date.now();
  const messagesLength = endOfCallReport.artifact?.messages?.length || 0;
  
  const data = isMissedCall ? undefined : (
    endOfCallReport.endedReason === 'voicemail' ?
    endOfCallReport.assistant?.voicemailMessage :
    endOfCallReport.analysis?.summary
  );

  const callEvents = [];

  if (endOfCallReport.artifact?.messages) {
    callEvents.push({
      status: 'Call Connected',
      date: new Date(endOfCallReport.artifact?.messages[1]?.time).toISOString()
    });
  }

  if (endOfCallReport.artifact?.messages) {
    callEvents.push({
      status: 'Call Ended',
      date: new Date(endOfCallReport.artifact?.messages[messagesLength - 1]?.time).toISOString()
    });
  }

  const conversation = [];

  if (endOfCallReport.startTime) {
    conversation.push({
      recordId: recordId,
      itemType: "event",
      ts: new Date(endOfCallReport.startTime).toISOString(),
      content: "Call Connected",
      isIncoming: false,
      callId: callId,
      assistant: {
        avatar: "PLACEHOLDER",
        name: "PLACEHOLDER"
      }
    });
  }

  if (endOfCallReport.artifact?.messages) {
    endOfCallReport.artifact.messages
      .filter((msg: any) => msg.role !== 'system')
      .forEach((msg: any) => {
        conversation.push({
          recordId: recordId,
          itemType: "conversation",
          ts: new Date(msg.time).toISOString(),
          content: msg.message,
          isIncoming: msg.role === 'user',
          callId: callId,
          assistant: {
            avatar: "PLACEHOLDER",
            name: "PLACEHOLDER"
          }
        });
      });
  }

  if (endOfCallReport.endTime) {
    conversation.push({
      recordId: recordId,
      itemType: "event",
      ts: new Date(endOfCallReport.endTime).toISOString(),
      content: "Call Ended",
      isIncoming: false,
      callId: callId,
      assistant: {
        avatar: "PLACEHOLDER",
        name: "PLACEHOLDER"
      }
    });
  }
  const presignedUrl = (!isMissedCall && endOfCallReport.recordingFileObjKey)
    ? await ConversationService.getRecordingPresignedUrl(endOfCallReport.recordingFileObjKey)
    : null;

  const result: any = {
    itemType,
    itemActionStatus,
    callSummary,
    duration,
    callId,
    isIncoming,
    recordId,
    callEvents,
  };

  if (!isVoicemail) {
    result.conversation = conversation
  }

  if (!isMissedCall) {
    result.data = data;
  }

  if (!isMissedCall) {
    result.recordingUrl = presignedUrl;
    result.recordingFileObjKey = endOfCallReport.recordingFileObjKey;
  }

  return result;
}
